import { Insurance } from '@/components/insurance';
export default Insurance;
